import CardHolder from '@/components/_modules/Programs/Card-cards/CardHolder.vue'

export default {
  'Date': {
    label: 'Date',
    width: 100
  },

  'Action': {
    label: 'Action',
    width: 180
  },

  'CardNumber': {
    label: 'Card',
    compose: maskedCardNumber,
    width: 100
  },

  'CardHolder': {
    label: 'Card Holder',
    render: CardHolder,
    width: 180
  },

  NameOnCard: '_',

  'LoggedInUser': {
    label: 'User',
    width: 180
  },

  'Description': {
    label: 'Description',
    width: 250
  },

  'AccountID': '_',

  'HolderUserID': '_'
}

function maskedCardNumber(card) {
  if (card && card.data && card.data.CardNumber) {
    return '****' + card.data.CardNumber
  } else {
    return '****'
  }
}



// WEBPACK FOOTER //
// ./src/components/_modules/Programs/Card-history/model.js